import { useCallback, useState } from 'react';
import { useMedplum } from '@medplum/react';

interface UsePdfDownloadReturn {
  loading: boolean;
  openPdf: (url: string) => Promise<void>;
}

// Hook for downloading a PDF from a Binary URL and opening it in a new tab.
export const usePdfDownload = (): UsePdfDownloadReturn => {
  const medplum = useMedplum();
  const [loading, setLoading] = useState(false);

  const openPdf = useCallback(
    async (url: string) => {
      setLoading(true);
      try {
        const blob = await medplum.download(url);
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl, '_blank');
        setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
      } catch (err) {
        console.error('Error opening PDF:', err);
      } finally {
        setLoading(false);
      }
    },
    [medplum]
  );

  return { loading, openPdf };
};
